"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkout = void 0;
var _checkoutGodmode = require("@ori/checkout-godmode");
var _checkoutNotifications = require("@ori/checkout-notifications");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _navigationContext = require("../../contexts/navigationContext");
var _logger = require("../../logger");
var _models = require("../../models");
var _utils = require("../../utils");
var _CheckoutNavigation = require("../CheckoutNavigation");
var _CheckoutSummary = require("../CheckoutSummary");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const RegistrationWrapper = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../RegistrationWrapper/RegistrationWrapper'))));
const Checkout = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    shoppingContext: {
      isAnonymous,
      notifications
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    isRegistrationVisible,
    selectedStep
  } = (0, _navigationContext.useNavigationContext)();
  (0, _react.useEffect)(() => {
    // eslint-disable-next-line curly -- To be removed after eslint rules update
    if (isAnonymous) return;
    _jsCookie.default.remove('registrationId');
  }, [isAnonymous]);
  const {
    Step,
    StepSkeleton,
    stepLabelKey,
    notificationTypes
  } = _utils.CheckoutStepsSettings[selectedStep];
  const notificationMessages = notifications?.filter(notification => notificationTypes.includes(notification.notificationAppearance));
  (0, _logger.logDebug)('Rendering Checkout.tsx ...', {
    isAnonymous,
    isRegistrationVisible,
    selectedStep,
    stepLabelKey
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [isAnonymous && isRegistrationVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RegistrationWrapper, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Layout, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutNavigation.CheckoutNavigation, {
        stepLabelKey: stepLabelKey
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StepWrapper, {
        "data-testid": getTestId(_models.TestId.StepWrapper),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutNotifications.NotificationsController, {
          notificationMessages: notificationMessages
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(StepSkeleton, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Step, {})
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SummaryWrapper, {
        isHiddenWhenSmall: selectedStep === _models.ShoppingStep.Basket,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutSummary.CheckoutSummary, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutGodmode.GodMode, {})]
  });
};
exports.Checkout = Checkout;